import { QueryKeys } from "../../utils/queryKeys";

export const teacherFinalAssessmentKeys = {
      all: [QueryKeys.TEACHER_FINAL_ASSESSMENT_KEYS],
    
      getTeacherFinalAssessmentKeys: (args) => {
        const { userId } = args;
    
        return [...teacherFinalAssessmentKeys.all, userId];
      },
}